// Components==============
import Column from 'components/UI/ExerciseColumn/Column';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import Row from '../Row/Row';
import { TilesContext } from '../Tiles';
import './Category.module.scss';
// =========================

type Props = {
    name: string;
    pivot?: string | null;
    id?: number;
    image?: string | null;
    words?: Words[];
    column?: number;
    isSound?: 0 | 1;
};

const categoryVariants = {
    visible: {
        opacity: 1,
    },
    hidden: {
        opacity: 0,
    },
};

export default function Category({ name, pivot, image, isSound }: Props) {
    const { answer } = useContext(TilesContext);
    const [triggerAnimation, setTriggerAnimation] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setTriggerAnimation(false);
        }, 1000);
    }, [triggerAnimation]);

    const columnProps = {
        image,
        useWords: 1 as 1,
        useImages: 0 as 0,
        useCategories: false,
        isSound,
        background: 'city' as 'city',
    };

    return (
        <motion.div
            styleName="wrapper single-item"
            variants={categoryVariants}
            style={{
                pointerEvents: name === answer?.name ? 'initial' : 'none',
            }}
            animate={name === answer?.name ? 'visible' : 'hidden'}
            initial="hidden"
            exit="hidden"
        >
            <Column name={pivot || name} {...columnProps}>
                <Row name={name} withImage={false} id="column-1-row-1" />
            </Column>
        </motion.div>
    );
}
